import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";

export function useRejectVersion(
  category: SourceOrgCategory,
  orgId: string,
  docId: string
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      ingestApi.rejectDocumentVersion(category, orgId, docId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["listDocumentVersions", category, orgId, docId],
      });
    },
  });
}
